import React from 'react';

import {components} from 'react-select';
import styled from 'styled-components';

import {BaseUserAvatar} from 'app/components/general/avatars/BaseUserAvatar';
import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

import {UserSerializedType} from 'sweet-types';

type Props = {
  innerProps: {
    className?: string;
  };
  data: UserSerializedType;
};
export class SelectUsersMultiValueLabel extends React.Component<Props> {
  render(): JSX.Element {
    const {data, innerProps} = this.props;
    return (
      <StyledLabelDiv className={`Select-value ${innerProps.className || ''}`}>
        <BaseUserAvatar multiple={true} user={data} />
        <span className="value-name">
          {data.is_guest_until != null ? (
            <LazyTooltip tooltip={gt('Guest')}>
              <i className="fas fa-user-clock mr-1 text-info" />
            </LazyTooltip>
          ) : null}
          {data.is_deleted ? (
            <LazyTooltip
              tooltip={gt('No longer a member of this SweetProcess account.')}
            >
              <i className="fas fa-exclamation-triangle mr-1 text-secondary" />
            </LazyTooltip>
          ) : null}

          {data.name || data.email}
        </span>
      </StyledLabelDiv>
    );
  }
}

const StyledLabelDiv = styled.div`
  position: relative;

  .avatar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 27px;
    height: 27px;

    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  .value-name {
    margin-left: 27px;
    text-shadow: 1px 1px 1px #fff;
    font-size: 0.9rem;
  }
`;

export const SelectUsersSingleValueLabel = (
  props: components.SingleValueProps
): JSX.Element => (
  <StyledSingleValueDiv>
    <BaseUserAvatar user={props.data} />
    {props.data.is_guest_until != null ? (
      <LazyTooltip tooltip={gt('Guest')}>
        <div className="d-flex align-items-center mx-1">
          <i className="fas fa-user-clock text-info" />
        </div>
      </LazyTooltip>
    ) : null}
    {props.data.is_deleted === true ? (
      <LazyTooltip
        tooltip={gt('No longer a member of this SweetProcess account.')}
      >
        <i className="fas fa-exclamation-triangle mr-1 text-secondary" />
      </LazyTooltip>
    ) : null}
    <div>
      <components.SingleValue {...props} />
    </div>
  </StyledSingleValueDiv>
);

const StyledSingleValueDiv = styled.div.attrs({
  className: 'd-flex',
})`
  .avatar {
    margin: -2px -8px;
    border-radius: 4px;
    margin-right: 0.25rem;
    width: 36px;
    height: 36px;
  }
`;
